import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { BranchData } from '@/common/types/cards/details.type'
import { CompanyBranchData } from '@/common/types/companyBranches.type'
import { CompanyData } from '@/features/company/types/company.type'
import { BriefcaseBusinessIcon, ChevronsRight } from 'lucide-react'

type CardDetailCompanyInformationProps = {
  company?: CompanyData
  companyBranch?: BranchData | CompanyBranchData
  fantasyName?: string
  branchDisplayName?: string
}

const CardDetailCompanyInformation = ({
  company,
  companyBranch,
  fantasyName,
  branchDisplayName,
}: CardDetailCompanyInformationProps) => {
  return (
    <div className="flex items-center gap-x-2 flex-wrap">
      <ImageWithPlaceholder
        placeholderIcon={BriefcaseBusinessIcon}
        url={company?.general_information?.company_logo?.url}
        className="size-6 sm:size-9"
        iconClassName="size-4 sm:size-6"
      />

      <p className="text-base sm:text-[22px] font-bold">
        {fantasyName || company?.general_information?.fantasy_name ||
          company?.general_information?.official_name}
      </p>

      {(companyBranch || branchDisplayName) && (
        <>
          <ChevronsRight color="#ffffffb3" className="hidden sm:block" />

          <div className="w-full sm:hidden" />

          <p className="text-base sm:text-xl italic font-light pl-8 sm:pl-0">
            {branchDisplayName || companyBranch?.display_name}
          </p>
        </>
      )}
    </div>
  )
}

export default CardDetailCompanyInformation
